<template>
    <div class="feedbackList">
        <el-table class="data-table" :data="feedbackList" v-loading="loading">
        <el-table-column align="center" label="序号" width="50">
          <template slot-scope="scope">
            <div>
              {{ scope.$index + 1 + (page - 1) * 10 }}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="反馈时间" prop="created_at"></el-table-column>
        <el-table-column align="center" label="反馈账号" prop="nick_name"></el-table-column>
        <el-table-column align="center" label="反馈内容" prop="content"></el-table-column>
        <el-table-column align="center" label="图片">
            <template slot-scope="scope">
                <div>
                    <el-image v-if="scope.row.res[0]" style="width: 70px; height: 40px" :preview-src-list="scope.row.res" :src="scope.row.res[0]" fit="contain"></el-image>
                    <span v-else>暂无图片</span>
                </div>
            </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="onPageChange"
        :current-page="page"
        :page-size="10"
        layout="total, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
</template>

<script>
import { getFeedbackList } from "@/api/api"
export default {
    name: 'FeedbackList',
    data: () => {
        return {
            feedbackList: [],
            page: 1,
            total: 0,
            loading: false
        }
    },
    mounted() {
      this.onSearch()
    },
    methods: {
      onSearch() {
        this.loading = true
        getFeedbackList({ page: this.page }).then(res => {
          this.loading = false
          console.log('res', res)
          this.feedbackList = res.data.data.list
          this.total = res.data.data.total
        })
      },
      onPageChange(e) {
          this.page = e
          this.onSearch()
      }
    },
}
</script>

<style lang="less">

</style>
  